var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinkHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 85,
    viewBox: "0 0 83 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1618874566 2",
    clipPath: "url(#clip0_1489_2017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.8608 76.1015C33.8608 76.1015 19.9904 47.5099 16.0755 39.6388C11.138 29.6986 9.77917 12.6639 25.7301 7.65681C41.681 2.64977 49.4946 25.1509 47.3708 33.2538C47.3708 33.2538 62.0452 5.28901 74.8132 17.6138C87.5813 29.9387 69.9464 47.2285 61.357 56.2864C53.3797 64.3894 44.0836 71.0886 33.8608 76.1015Z",
    fill: "#F594A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1489_2017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 69,
    fill: "white",
    transform: "translate(19.2637) rotate(16.2118)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkHeart);
export default __webpack_public_path__ + "static/media/pinkHeart.38893645ac0a06cde71bdfc4b89d5685.svg";
export { ForwardRef as ReactComponent };